import React, { Component } from 'react';
import ga from 'react-ga';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { Container, Footer as TMTFooter } from 'tmt-ui-kit';
import styled from 'styled-components';

import { actions as sessionActions } from '~/redux/reducers/session';
import { currencies } from '~/utils/helpers';
import { getDefaultCurrency } from '~/utils/price';
import { countries, inverseCountryMap, countryMap } from '~/utils/countries';
import Link from '~/components/Link/Link';


moment.tz.setDefault('Asia/Bangkok');

const FooterContainer = styled.footer`
  width: 100%;
  background: rgb(240, 245, 247);
  margin: 0 auto;
`;


const enhance = connect((state) => ({
  user: state.session.user,
  sessionData: state.session.data,
  exchangeRates: state.info.exchangeRates,
}), {
  ...sessionActions,
});

class Footer extends Component {
  static propTypes = {
    setLocalSessionData: PropTypes.func,
    setSessionData: PropTypes.func,
    sessionData: PropTypes.object,
    user: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.onChangeCurrency = this.onChangeCurrency.bind(this);
    this.onChangeCountry = this.onChangeCountry.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.sessionData.currency !== nextProps.sessionData.currency) {
      return true;
    }
    if (this.props.sessionData.userType !== nextProps.sessionData.userType) {
      return true;
    }
    return false;
  }

  onChangeCurrency = (event) => {
    event.target.blur();
    const { value } = event.target;
    this.props.setLocalSessionData({ currency: value });
    this.props.setSessionData({ currency: value });
  };

  onChangeCountry = e => {
    e.target.blur();
    const country = countryMap[e.target.value];
    const updatedObj = {
      userType: {
        type: country,
        selected_at: moment().toDate()
      },
      currency: getDefaultCurrency(e.target.value)
    };
    this.props.setLocalSessionData(updatedObj);
    this.props.setSessionData(updatedObj);
    window.requestIdleCallback(() => {
      ga.set({ dimension1: country }, ['auTracker']);
      ga.event({ category: 'User', action: 'Classify User' }, ['auTracker']);
    });
    if (window.hj) {
      window.hj('tagRecording', [country]);
    }
  };

  render() {
    const { sessionData } = this.props;
    const country = sessionData.userType ? inverseCountryMap[sessionData.userType.type] : '';
    return (
      <FooterContainer>
        <Container.InnerContainer>
          <TMTFooter
            selectedCurrency={sessionData.currency}
            currencyOption={currencies}
            handleCurrencyChange={this.onChangeCurrency}
            selectedCountry={country}
            countryOption={countries}
            handleCountryChange={this.onChangeCountry}
            // footerLink
            footerLink={{
              getStarted: <Link to="/get-started" />,
              trustAndSaFety: <Link to="/trust-and-safety" />,
              article: <Link to="/ebook/floating-markets-in-and-around-bangkok" />,
              localExpertBenefits: <Link to="/local-expert-benefits" />,
              aboutus: <Link to="/about-us" />,
              career: <Link to="/career" />,
              sitemap: <Link to="/sitemap" />,
              listing: this.props.user.is_local_expert ? <Link to="/dashboard/listing" /> : <a href="/local-expert-benefits" />,
              helpcenter: <Link to="/help-center" />,
              affiliate: <Link to="/affiliate" />,
              trustAndSafety: <Link to="/trust-and-safety" />,
              influencer: <Link to="/influencer" />,
            }}
            // citiesLink
            citiesLink={{
              ayutthayaTours: <Link to="/to/Ayutthaya" />,
              bangkokTours: <Link to="/to/Bangkok" />,
              toursFromBangkok: <Link to="/activity?city=Near Bangkok" />,
              chiangMaiTours: <Link to="/to/Chiang Mai" />,
              toursFromChiangMai: <Link to="/activity?city=Near Chiang Mai" />,
              chiangRaiTours: <Link to="/to/Chiang Rai" />,
              hatYaiTours: <Link to="/to/Hat Yai" />,
              huaHinTours: <Link to="/to/Hua Hin" />,
              kanchanaburiTours: <Link to="/to/Kanchanaburi" />,
              khaoYaiTours: <Link to="/to/Nakhon Ratchasima" />,
              kohSamuiTours: <Link to="/to/Surat Thani" />,
              krabiTours: <Link to="/to/Krabi" />,
              pattayaTours: <Link to="/to/Pattaya" />,
              phuketTours: <Link to="/to/Phuket" />,
              toursFromPhuket: <Link to="/activity?city=Near Phuket" />,
              centralThailandTours: <Link to="/activity?city=Central Thailand" />,
              easternThailandTours: <Link to="/activity?city=Eastern Thailand" />,
              northeasternThailandTours: <Link to="/activity?city=Northeastern Thailand" />,
              northernThailandTours: <Link to="/activity?city=Northern Thailand" />,
              southernThailandTours: <Link to="/activity?city=Southern Thailand" />,
            }}
            // topActivitiesLink
            topActivitiesLink={{
              cityTour: <Link to="/to/Bangkok/famous-attractions?focus=grand-palace-and-highlights" />,
              natural: <Link to="/to/Bangkok/local-experiences?focus=best-nature-scenery" />,
              floatingMarket: <Link to="/to/Bangkok/famous-attractions?focus=khlong-lat-mayom" />,
              cookingClass: <Link to="/to/Bangkok/local-experiences?focus=cooking-at-home" />,
              beach: <Link to="/to/Bangkok/local-experiences?focus=hua-hin-in-day" />,
              cycling: <Link to="/to/Bangkok/local-experiences?focus=bike-tour-in-bangkok-s-green-lung" />,
              boating: <Link to="/to/Bangkok/local-experiences?focus=canal-boat-tour" />,
              streetFood: <Link to="/to/Bangkok/local-experiences?focus=eat-local" />,
              propertyTours: <Link to="/bangkok-property-tours" />,
            }}
          />
        </Container.InnerContainer>
      </FooterContainer>
    );
  }
}

export default enhance(Footer);
